import { moreTransactionBeforeSave } from "services/sosInventoryService/moreTransaction/beforeSave";
import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/rental/schema";
import { normalizeDateFields } from "services/utility/beforeSave";

import { OBJECT_TYPES } from "appConstants";

const OBJECT_TYPE = OBJECT_TYPES.RENTAL.fullString;

export function beforeSave(record) {
  const newRecord = moreTransactionBeforeSave(OBJECT_TYPE, record);
  return normalizeDateFields(newRecord, FIELDS_TO_TRANSFORM.DATE_FIELDS);
}
